import { z } from "zod";

export const featureFlagSchema = z.object({
  id: z.number(),
  name: z.string(),
  allowed_for_domains: z.string().nullable(),
  allowed_for_user_ids: z.string().nullable(),
});

export const globalMessageSchema = z.object({
  id: z.number(),
  title: z.string().nullable(),
  content: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type FeatureFlag = z.infer<typeof featureFlagSchema>;
export type GlobalMessage = z.infer<typeof globalMessageSchema>;
